import React, { useEffect, useState } from 'react';
import SEO from '@components/seo';
import Layout from '@layouts/default-layout';
import Module from '@components/module';
import Sidenav from '@components/sidenav';
import { ModuleContent, SidebarWrapper } from './page.styled';
var Page = function Page(_ref) {
    var data = _ref.data;
    if (!data)
        return null;
    var _data$allPrismicGuide = data.allPrismicGuidelinePagesSchema.edges[0].node.data, body = _data$allPrismicGuide.body, page_title = _data$allPrismicGuide.page_title;
    var faviconHref = data.prismicMainPageSchema.data.favicon.url;
    var _useState = useState(false), hasRan = _useState[0], setHasRan = _useState[1];
    var _useState2 = useState(''), urlString = _useState2[0], setUrlString = _useState2[1];
    useEffect(function () {
        var hash = window.location.hash.substring(1);
        var element = document.getElementById(hash);
        if (!hasRan) {
            setHasRan(true);
            setUrlString("" + window.location.origin + window.location.pathname);
        }
        setTimeout(function () {
            window.scrollTo({
                behavior: element ? 'smooth' : 'auto',
                top: element ? element.offsetTop : 0
            });
        }, 100);
    }, []);
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: page_title.text,
        faviconHref: faviconHref
    }), /*#__PURE__*/ React.createElement(SidebarWrapper, null, /*#__PURE__*/ React.createElement(Sidenav, {
        pageTitle: page_title.text,
        body: body
    }), /*#__PURE__*/ React.createElement(ModuleContent, null, body.map(function (_ref2) {
        var slice_type = _ref2.slice_type, slice_label = _ref2.slice_label, primary = _ref2.primary, items = _ref2.items, id = _ref2.id;
        return /*#__PURE__*/ React.createElement(React.Fragment, {
            key: id
        }, /*#__PURE__*/ React.createElement(Module, {
            url: urlString,
            type: slice_type,
            label: slice_label,
            primary: primary,
            items: items,
            ind: id
        }));
    }))));
};
export default Page;
var query = "1540027023";
